import { FormSelect, FormSelectProps } from '../index';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

type FormYesNoFieldProps = Omit<FormSelectProps, 'options'> & { max?: number };

export const FormYesNoField: FC<FormYesNoFieldProps> = (props) => {
  const { t } = useTranslation('common');
  return (
    <FormSelect
      {...props}
      options={[
        { text: t('YES'), value: 1 },
        { text: t('NO'), value: 0 }
      ]}
    />
  );
};
